// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.LoginRegister.View'
,	[
	'c3_shoppingextensions_loginregister.tpl'
	,  'Profile.Model'
	//,	'NXTurn.ShoppingExtensions.LoginRegister.SS2Model'
	,   'Backbone.CompositeView'
	,	'Backbone'
	,    'Tracker'
	//,	'SC.Configuration'
	,   'C3.ShoppingExtensions.LoginRegister.Login.View'
	,   'C3.ShoppingExtensions.LoginRegister.Register.View'
    ]
, function (
	c3_shoppingextensions_loginregister_tpl
	,   ProfileModel
	//,	LoginRegisterSS2Model
	,   BackboneCompositeView
	,	Backbone
	,   Tracker
	//,   Configuration
	,   LoginView
	,   RegisterView
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_loginregister_tpl

	,   modalClass: 'global-views-modal-small'	

	,   beforeShowContent: function beforeShowContent() {
        const promise = jQuery.Deferred();
        const profileModel = ProfileModel.getInstance();

        if (profileModel.get('isLoggedIn') === 'T' && profileModel.get('isGuest') === 'F') {
            Backbone.history.navigate('', { trigger: true });

            promise.reject();
        } else {
            promise.resolve();
        }

        return promise;
    }

	,	initialize: function (options) {
		const { application } = options;
		const profile_model = ProfileModel.getInstance();

        this.child_view_options = {
            application: application,
            parentView: this,
            timedout: options.timedout
        };

		BackboneCompositeView.add(this);

        this.on('afterViewRender', this.trackStep, this);
			
		}

	,   trackStep: function() {
        Tracker.getInstance().trackPageviewForCheckoutStep(1);
    }	
	
	,   events: {
        // login error message could contain link to registration page
        'click .alert-error a': 'handleErrorLink'
    }

    ,  handleErrorLink: function(e) {
        // if the link contains the register touch-point
        if (~e.target.href.indexOf(Configuration.get('siteSettings.touchpoints.register'))) {
            e.preventDefault();
            this.showRegistrationForm();

            this.childViewInstances.Login.hideError();
        }
    }

	,	bindings: {
		}

	, 	childViews: {
		Login: function() {
            return new LoginView(this.child_view_options);
        },
        Register: function() {
            return new RegisterView(this.child_view_options);
        }
		}

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			
			return {
				
			};
		}
	});
});
